import script from "./ProductReviewForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductReviewForm.vue?vue&type=script&setup=true&lang=js"

import "./ProductReviewForm.vue?vue&type=style&index=0&id=6fc593a4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc593a4"]])

export default __exports__